//公司测试公众号
// export const appId = 'wx0080dc282019bd34'
// export const requestUrl = 'http://www.mjxxkj.cn/'
//开发环境
//export const appId = 'wx9553568019298690'
//export const requestUrl = 'http://127.0.0.1:9080'

//生产环境
 export const appId = 'wx136b234f2a5c2e8b'
 export const requestUrl = 'http://yy.zjsjtk.cn'